import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ProductOne from "../../assets/img/2.png";
import { KeyboardArrowDown } from "@mui/icons-material";
import useWindowWidth from "../../hooks/useWindowWidth";

export default function SingleProductCardForCarousel({img, title}) {
  const windowWidth = useWindowWidth()
  return (
    <div
    className="product_card"
    style={{
      height:windowWidth <= 1500  ? "280px":"320px",
      width: windowWidth <= 1500  ? "160px" :"200px",
      position: "relative",
      background: "white",
      padding: "10px",
      borderRadius: "20px",
    }}
  >
    <img
      src={img || ProductOne}
      alt="product"
      style={{
        width: "100%",
        height: windowWidth <= 1500  ? "110px": "150px",
        objectFit: "cover",
        borderRadius: "20px",
      }}
    />
    <div
      style={{
        width: "100%",
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
    >
      <h5
        style={{
          fontSize: windowWidth <= 1500 ? "12px":"14px",
          color: "#212B36",
          textOverflow: "ellipsis",
          overflow: "hidden",
          marginBottom: "0px",
          marginTop: "10px",
        }}
      >
        <>{title}</>
      </h5>
    </div>
    <h6 style={{ fontWeight: 500, fontSize:windowWidth <= 1500 ? "12px":"14px", }}>€ 59.43</h6>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        bottom: "10px",
        position: "absolute",
        left: 0,
        width: "90%",
        margin: "5%",
      }}
    >
      <VisibilityIcon
        style={{
          color: "#8D40FF",
        }}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            color: "#fff",
            padding: "8px",
            fontSize: "12px",
            zIndex: 999,
            backgroundColor: "#8D40FF",
            borderRadius: "8px 0 0 8px",
            transition: "0.3s all ease-in-out",
          }}
        >
          Get Quote
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "8px",
            backgroundColor: "#8D40FF",
            borderRadius: "0 8px 8px 0",
            transition: "0.3s all ease-in-out",
          }}
        >
          <KeyboardArrowDown sx={{ color: "white", fontSize: "18px" }} />
        </div>
      </div>
    </div>
  </div>
  )
}
